import React, { useState, useRef, useEffect } from 'react';
import './ColumnVisibilityMenu.css';
import './TableActionsMenu.css';

const GearIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true">
    <path
      d="M12 15.5A3.5 3.5 0 1 0 12 8.5a3.5 3.5 0 0 0 0 7z"
      strokeLinejoin="round"
    />
    <path
      d="M19.4 15a1.7 1.7 0 0 0 .34 1.87l.06.06a2.1 2.1 0 0 1-1.5 3.58 2.1 2.1 0 0 1-1.49-.62l-.06-.06a1.7 1.7 0 0 0-1.87-.34 1.7 1.7 0 0 0-1 1.55V21a2.1 2.1 0 0 1-4.2 0v-.09a1.7 1.7 0 0 0-1-1.55 1.7 1.7 0 0 0-1.87.34l-.06.06a2.1 2.1 0 0 1-3.58-1.5 2.1 2.1 0 0 1 .62-1.49l.06-.06A1.7 1.7 0 0 0 4.6 15a1.7 1.7 0 0 0-1.55-1H3a2.1 2.1 0 0 1 0-4.2h.09a1.7 1.7 0 0 0 1.55-1 1.7 1.7 0 0 0-.34-1.87l-.06-.06A2.1 2.1 0 0 1 5.74 2.9a2.1 2.1 0 0 1 1.49.62l.06.06a1.7 1.7 0 0 0 1.87.34H9.2a1.7 1.7 0 0 0 1-1.55V3a2.1 2.1 0 0 1 4.2 0v.09a1.7 1.7 0 0 0 1 1.55 1.7 1.7 0 0 0 1.87-.34l.06-.06a2.1 2.1 0 0 1 3.58 1.5 2.1 2.1 0 0 1-.62 1.49l-.06.06a1.7 1.7 0 0 0-.34 1.87V9.2a1.7 1.7 0 0 0 1.55 1H21a2.1 2.1 0 0 1 0 4.2h-.09a1.7 1.7 0 0 0-1.55 1z"
      strokeLinejoin="round"
    />
  </svg>
);

export default function ColumnVisibilityMenu({
  columns,
  hiddenIds,
  onToggle,
  onShowAll,
  title = 'עמודות להצגה',
}) {
  const [open, setOpen] = useState(false);
  const menuRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const visibleCount = columns.filter((col) => !hiddenIds.has(col.columnId)).length;
  const hiddenCount = columns.length - visibleCount;

  return (
    <div className="column-visibility-menu" ref={menuRef}>
      <button
        type="button"
        className="report-action-btn report-action-btn--settings report-action-btn--icon"
        onClick={() => setOpen((prev) => !prev)}
        data-tooltip="הגדרת עמודות"
        aria-label="הגדרת עמודות"
        aria-expanded={open}
      >
        <GearIcon />
      </button>

      {open && (
        <div className="column-visibility-panel" role="dialog" aria-label={title}>
          <div className="column-visibility-header">
            <span className="column-visibility-title">{title}</span>
            {hiddenCount > 0 && (
              <button
                type="button"
                className="column-visibility-show-all"
                onClick={() => onShowAll?.()}
              >
                הצג הכל
              </button>
            )}
          </div>

          <ul className="column-visibility-list">
            {columns.map((col) => {
              const columnId = col.columnId;
              const isVisible = !hiddenIds.has(columnId);
              const isLastVisible = isVisible && visibleCount <= 1;

              return (
                <li key={columnId}>
                  <label className={`column-visibility-item${isLastVisible ? ' column-visibility-item--locked' : ''}`}>
                    <input
                      type="checkbox"
                      checked={isVisible}
                      disabled={isLastVisible}
                      onChange={() => onToggle?.(columnId)}
                    />
                    <span>{col.label || col.field}</span>
                  </label>
                </li>
              );
            })}
          </ul>
        </div>
      )}
    </div>
  );
}
